"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("lepont/browser");
const shared_1 = require("./shared");
/**
 * Sets the item to the async storage.
 */
async function setItem(key, value) {
    await browser_1.sendMessage({
        type: shared_1.MSG_TYPE_SET_ITEM,
        payload: {
            key,
            value,
        },
    });
}
exports.setItem = setItem;
/**
 * Gets the item from the async storage.
 */
async function getItem(key) {
    const json = await browser_1.sendMessage({
        type: shared_1.MSG_TYPE_GET_ITEM,
        payload: { key },
    });
    return json;
}
exports.getItem = getItem;
